/* eslint-disable no-unused-vars */
import DataTable from '@/containers/data_table_ml/DataTable';
import styles from './TablePage.less?modules';
import './TablePage.less';
import ButtonML from '@/components/button_ml/ButtonML';
import dayjs from 'dayjs';
import { useSelector, useDispatch } from 'dva';
import React, { useState } from 'react';
import { CaretRightFilled, CaretDownFilled } from '@ant-design/icons';
import { message, Menu } from 'antd';
import Loading from '@/components/Loading';
import DropDown from '@/components/dropdown/Dropdown';
import { history } from 'umi';
import TableLinkML from '@/containers/data_table_ml/table_link_ml/TableLinkML';
import { useTrigger } from '@/utils/comHook.js';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import ModalConfirmML from '@/components/modal_ml/modal_confirm_ml/ModalConfirmML';
import Update from '@/containers/update_ml/Update';

const TablePage = (props) => {
  const dispatch = useDispatch();
  const deleteTrigger = useTrigger();

  const { addRuleChange } = props || {};
  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['ruleManage/getRuleManaList'];
  const delLoading = loadingEffect.effects['ruleManage/getRuleManaList'];
  const data = useSelector((state) => state.ruleManage.getRuleManaList);
  // const [delLoading, setDelLoading] = useState(false);
  const [nowRecordParentId, setNowRecordParentId] = useState(undefined);
  const [nowRecordId, setNowRecordId] = useState(undefined);
  const [nowOpen, setNowOpen] = useState(undefined);
  let isObject = Object.prototype.toString.call(data) === '[object Object]';

  //获取数据给最后一阶段加上标志(仅限于三级目录)
  const deleteEmptyArr = (datas) => {
    if (isObject) {
      return;
    }
    datas.map((item) => {
      const { children = [] } = item || {};
      (children || []).map((item1) => {
        const { children: children1 = [] } = item1 || {};
        (children1 || []).map((item2) => {
          item2.isLastChild = true;
        });
        item1.isLastChild = false;
        return item;
      });
      item.isLastChild = false;
      return item;
    });
  };
  if (data) {
    deleteEmptyArr(data);
  }

  //删除规则
  const deleteRuleChange = (values) => {
    // setDelLoading(true);
    dispatch({
      type: 'ruleManage/deleteRuleManaList',
      payload: {
        values: {
          ...values,
        },
      },
      callback: (res) => {
        // setDelLoading(false);
        const { code } = res || {};
        if (code === 1) {
          message.warning('里面含有子项，不能删除');
          return;
        }
        message.success('删除成功');
        props.fetchData();
      },
    });
  };
  //进入三级目录规则详情
  const handleDetail = (record) => {
    history.push({
      pathname: '/bre/rm/rule',
      query: { id: record.id, editable: record.editable },
    });
  };
  // 导入
  const action = (e) => {
    const formData = new FormData();
    formData.append('uploadFile', e);
    dispatch({
      type: 'ruleManage/uploadFile',
      payload: {
        values: formData,
        id: nowRecordParentId,
      },
      callback: (res) => {
        if (res && res.code === 2) {
          message.error('导入文件内容不符合规格');
        } else {
          message.success('导入成功');
        }
      },
    });
  };
  // 导出
  const handleExport = () => {
    dispatch({
      type: 'ruleManage/exportFieldPackage',
      payload: {
        id: nowRecordId,
      },
      callback: (res) => {
        if (!res) {
          message.error('请求数据异常!');
          return;
        }
        const blob = new Blob([res], {
          type: 'application/json; charset=utf-8',
        });
        const fileName = new Date().getTime() + '.json';
        if (window.navigator.msSaveOrOpenBlob) {
          // IE10+
          navigator.msSaveBlob(blob, fileName);
          message.success('导出成功');
        } else if ('download' in document.createElement('a')) {
          // 非IE
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          document.body.appendChild(link);
          link.style.display = 'none';
          link.click();
          window.URL.revokeObjectURL(link.href);
          link.remove();
          message.success('导出成功');
        } else {
          message.error('当前浏览器不支持!');
        }
      },
    });
  };
  //下拉的menu
  const menu = (
    <Menu>
      <Menu.Item>{<Update action={action} accept=".json" />}</Menu.Item>
      <Menu.Item onClick={handleExport}>导出</Menu.Item>
    </Menu>
  );

  const columns = [
    {
      title: '规则包名称',
      dataIndex: 'name',
      key: 'name',
      width: 150,
      render: (text, record) =>
        record.isLastChild ? (
          <span>
            <TableLinkML text={text} handleClick={() => handleDetail(record)} />
          </span>
        ) : (
          <span>
            <TableLinkML text={text} />
          </span>
        ),
    },
    {
      title: '规则描述',
      dataIndex: 'description',
      key: 'description',
      width: 200,
    },
    {
      title: '更新时间',
      dataIndex: 'updateTime',
      key: 'updateTime',
      width: 200,
      render: (text) => (
        <span>{dayjs(text).format('YYYY-MM-DD HH:mm:ss')}</span>
      ),
    },
    {
      title: '规则包状态',
      dataIndex: 'ruleBlockStatus',
      key: 'ruleBlockStatus',
      width: 50,
      render: (text) => {
        return (
          <span>
            {text === 'ENABLE'
              ? '启用'
              : text === 'INDETERMINATE'
              ? '不确定'
              : '禁止'}
          </span>
        );
      },
    },
    {
      title: '操作',
      render: (record) => {
        return (
          <div className={styles.handle_btn}>
            {record.isLastChild ? (
              ''
            ) : (
              <ButtonML
                size="large"
                value="新增"
                onClick={() => addRuleChange && addRuleChange(record, 'add')}
              />
            )}
            <ButtonML
              size="large"
              value="编辑"
              onClick={() => addRuleChange && addRuleChange(record, 'edit')}
              disabled={String(record?.editable) === 'false'}
            />
            <ModalConfirmML
              title="是否确认删除?"
              handleOk={() => deleteRuleChange(record)}
              handleCancel={deleteTrigger.close}
              visible={deleteTrigger.visible}
              value="删除"
              icon={<ExclamationCircleOutlined />}
              disabled={String(record?.editable) === 'false'}
            />
            {/* {record.isLastChild ? (
              // <ButtonML
              //   size="large"
              //   value="其他操作"
              //   onClick={() => handleMemberDetail(record, 'detail')}
              // />
              <DropDown
                menu={menu}
                onVisibleChange={() => {
                  setNowRecordParentId(record.parentId);
                  setNowRecordId(record.id);
                }}
                btnVal="其他操作"
                disabled={record.String(editable) === 'false'}·
              />
            ) : (
              ''
            )} */}
          </div>
        );
      },
      width: 200,
    },
  ];
  return (
    <Loading loading={delLoading}>
      <DataTable
        className="demo-test"
        // style={{ minWidth: '1547px' }}
        columns={columns}
        rowSelection={false}
        scroll={{ x: '1247px', y: 'calc(100vh - 160px - 3rem)' }}
        dataSource={isObject ? [] : data}
        // loading={loading}
        isTree={true}
        rowKey={(v) => v.id}
        expandable={{
          expandedRowKeys: nowOpen,
          expandIcon: ({ expanded, onExpand, record }) => {
            const { children = [] } = record || {};
            return expanded ? (
              children.length ? (
                <CaretDownFilled
                  className="table_icon"
                  onClick={(e) => onExpand(record, e)}
                />
              ) : (
                <span className={styles.hiddenIcon}></span>
              )
            ) : children.length ? (
              <CaretRightFilled
                className="table_icon"
                onClick={(e) => onExpand(record, e)}
              />
            ) : (
              <span className={styles.hiddenIcon}></span>
            );
          },
          expandRowByClick: true,
          indentSize: 20,
          onExpandedRowsChange: (expandedRows) => {
            console.log(expandedRows);
            setNowOpen(expandedRows);
          },
        }}
        // changePage={(a) => {
        //   props.pageNumChange(a);
        // }}
        // changePageSize={(a) => {
        //   props.pageSizeChange(a);
        // }}
      />
    </Loading>
  );
};
export default TablePage;
